/**
 * Menu PropTypes
 *
 * PropType definitions for navigation menu items and submenu structures.
 * Used in header navigation and mobile menu components.
 *
 * @module propTypes/menu
 */

import PropTypes from "prop-types";

/**
 * Sub menu item shape
 * Represents a single item in a dropdown submenu
 *
 * @property {string} label - Display label
 * @property {string} url - Link URL/path
 * @property {boolean} external_link - Whether link opens in new tab
 */
export const subMenuItemShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  external_link: PropTypes.bool,
});

/**
 * Menu item shape
 * Represents a main navigation menu item with optional submenu
 *
 * @property {string} label - Display label
 * @property {string} url - Link URL/path
 * @property {boolean} external_link - Whether link opens in new tab
 * @property {Array} sub_items - Array of submenu items (optional)
 */
export const menuItemShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  external_link: PropTypes.bool,
  sub_items: PropTypes.arrayOf(subMenuItemShape),
});
